// extracted by mini-css-extract-plugin
export default {"single-transfer":"single-transfer_single-transfer__k-bff","single-transfer__details":"single-transfer_single-transfer__details__URJiS"};